import { render, staticRenderFns } from "./ExhibitionHall.vue?vue&type=template&id=764f6a06&scoped=true"
import script from "./ExhibitionHall.vue?vue&type=script&lang=js"
export * from "./ExhibitionHall.vue?vue&type=script&lang=js"
import style0 from "./ExhibitionHall.vue?vue&type=style&index=0&id=764f6a06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764f6a06",
  null
  
)

export default component.exports